<template>
  <div class="tw-bg-white tw-rounded-lg tw-p-6">
    <!-- CLOSE BUTTON -->
    <CloseButton @click="closeDialog" />

    <!-- LOGO -->
    <Logo />

    <!-- TITLE -->
    <p
      class="
        tw-text-center tw-font-medium tw-text-base tw-text-black tw-mb-4
        xl:tw-text-2xl
      "
    >
      {{ title }}
    </p>

    <!-- CONTENT -->
    <!-- eslint-disable vue/no-v-html -->
    <p class="tw-mb-5 tw-text-center" v-html="content" />
    <!-- eslint-enable vue/no-v-html -->

    <!-- ICON -->
    <div class="tw-text-center tw-text-6xl">
      <component :is="icon" />
    </div>
  </div>
</template>

<script>
import AlertIcon from 'vue-material-design-icons/AlertCircle'
import CloseButton from './CloseButton'
import Logo from './Logo'

const variants = {
  error: { icon: AlertIcon },
}

export default {
  components: { AlertIcon, CloseButton, Logo },
  props: {
    title: {
      default: null,
      type: String,
    },
    content: {
      default: null,
      type: String,
    },
    variant: {
      default: 'error',
      type: String,
      validator: (value) => ['error'].includes(value),
    },
  },
  computed: {
    icon() {
      return variants[this.variant].icon
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>
